<mat-dialog-content>
  <div class="container content-global">
    <div class="row">
      <div class="content-dowload-excel col-sm-6">
        <div class="title">{{excelImportConfig.importTitle}}</div>
        
        <div class="content-button">
          <a *ngIf="!excelImportConfig.multiple" href="../../../../assets/format-excel/{{excelImportConfig.excelNameTemplate}}" download>
            <mat-icon svgIcon='download-template'></mat-icon>
          </a>
          <mat-icon *ngIf="excelImportConfig.multiple" svgIcon='download-template'></mat-icon>
        </div>

        <p><strong>{{excelImportConfig.importInfoBlacked}}</strong> {{excelImportConfig.importInfo}}</p>
        
        <div class="content-button">
         <a 
           *ngIf="!excelImportConfig.multiple"
            href="../../../../assets/format-excel/{{excelImportConfig.excelNameTemplate}}"
            mat-flat-button 
            class="button-export" 
            download>
            <span>Descargar</span>
          </a>
          <button
            *ngIf="excelImportConfig.multiple"
            mat-flat-button
            class="button-export"
            [matMenuTriggerFor]="menuPlantilla"
          >
            <span class="btn-header-txt">Descargar</span> 
          </button>
        </div>

        <mat-menu #menuPlantilla="matMenu">
          <ng-template matMenuContent>
           <!--  <button
              mat-menu-item
              *ngFor="let item of excelImportConfig.templateList"
            > -->
            <div class="list-options">
              <a class="chooseTemplates"
              *ngFor="let item of excelImportConfig.templateList"
              href="../../../../assets/format-excel/{{item.excelNameTemplate}}" 
              download
              >
              <div *ngIf="item.tripModes.includes(data.parameter)">
                <mat-icon class="icons" *ngIf="item.icon">{{item.icon}}</mat-icon>
                <mat-icon class="icons" *ngIf="item.svgIcon" [svgIcon]="item.svgIcon"></mat-icon>
                 <span>{{item.text}}</span>
              </div> 
                </a>
              </div>

            <!-- </button>  -->
          </ng-template>
        </mat-menu>

      </div>
      <div class="content-upload-excel col-sm-6">
        <div class="title">{{excelImportConfig.exportTitle}}</div>
        <div class="content-button">
          <mat-icon svgIcon='upload-excel' (click)="uploadExcel()"></mat-icon>
        </div>
        <p><strong>{{excelImportConfig.exportInfoBlacked}}</strong> {{excelImportConfig.exportInfo}}</p>
        <div class="content-button">
          <button 
            mat-flat-button 
            class="button-success" 
            (click)="uploadExcel()"
          > 
            <span>Subir archivo</span>
          </button>
          <input 
          type="file" 
          id="inputExcel" 
          #inputExcel 
          class="file" 
          (change)="upload($event)"
          accept=".xlsx, .XLSX, .xls, .XLS"
          [(ngModel)]="fileValue"
          multiple
        >
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<button id="closeAddAddress" mat-button mat-dialog-close class="dialog-close">
  <mat-icon>close</mat-icon>
</button>